import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/15 text-accent-400 border border-accent-500/20 mb-3">
            <i className="ri-star-line mr-1"></i>核心优势
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择琪琪影院
          </h2>
          <p className="mt-2 text-sm text-foreground-500">五大核心体验，重新定义在线观影</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {featureItems.map((item) => (
            <div
              key={item.title}
              className="group p-5 rounded-xl bg-background-50 border border-background-200/50 hover:border-primary-500/20 transition-all duration-200 flex flex-col items-center text-center"
            >
              <span className="w-14 h-14 rounded-2xl bg-primary-500/10 flex items-center justify-center mb-4 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-400`}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-800 mb-2 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}